import { useEffect, useMemo, useState } from "react";
// import { useEffect, useMemo, useState, useContext } from "react";
import { TabBar } from 'antd-mobile'
// import { TabBar, Modal } from 'antd-mobile'
import { useNavigate, useLocation } from "react-router-dom"
// import { ConditionLoading } from 'components/conditionLoading'
// import { UserContext } from 'utils/getContext'
// import { getPersonalService } from 'api/api'
import tabHome from "static/images/tabHome.svg"
import tabService from "static/images/tabService.svg"
import tabMine from "static/images/tabMine.svg"
import tabActHome from "static/images/tabActHome.svg"
import tabActService from "static/images/tabActService.svg"
import tabActMine from "static/images/tabActMine.svg"
// import recommend from 'static/images/recommend.png'
// import recommendAct from 'static/images/recommendC.png'
import { page } from "utils/constant";
import 'static/css/BpmTabBar.css'

/** 常量 */
const { SERVICE, MINE } = page
// const { SERVICE, MINE, RECOMMEND } = page

/** 导航部分 */
export function BpmTabBar() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  /**用户信息 */
  // const { userInfo } = useContext(UserContext)
  const [activeKey, setActiveKey] = useState('/')
  // ]

  const tabs = useMemo(() => {
    const tabs = [
      {
        key: '/',
        title: '首页',
        icon: activeTab(tabHome, tabActHome)
      },
      // {
      //   key: `/${RECOMMEND}`,
      //   title: '推荐',
      //   icon: activeTab(recommend, recommendAct)
      // },
      // {
      //   key: `/${SERVICE}`,
      //   title: '服务',
      //   icon: activeTab(tabService, tabActService)
      // },
      {
        key: `/${MINE}`,
        title: '我的',
        icon: activeTab(tabMine, tabActMine)
      }
    ]
    return tabs
  }, [])

  /** 点击导航 */
  function handleTabClick(key) {
    navigate(key, key === `/${SERVICE}` && { state: { defaultActiveKey: ['1', '2', '3', '4'] } })
  }

  /** 导航图标样式 */
  function activeTab(original, click) {
    return (active) => active ?
      <img width={24} height={24} src={click} alt='图标'></img> :
      <img width={24} height={24} src={original} alt='导航图标'></img>
  }

  // 获取当前页面的路由和key做对比
  useEffect(() => {
    // 获取当前路由
    const active = tabs.find(item => item.key === pathname)
    setActiveKey(active ? active.key : '/')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  // 当获取到用户信息后，第一次打开弹窗
  // useEffect(() => {
  //   const showModal = sessionStorage.getItem('showModal')
  //   if (userInfo) {
  //     if (showModal) return
  //     sessionStorage.setItem('showModal', 'true')
  //     Modal.show({
  //       content: <ConditionLoading type='modal' />,
  //       closeOnMaskClick: true,
  //     })
  //     getPersonalService().then(res => {
  //       Modal.clear()
  //       navigate('/recommend')
  //     })
  //   } else {
  //     sessionStorage.removeItem('showModal')
  //     sessionStorage.removeItem("recommendList")
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [userInfo])

  return (
    <TabBar className='tabBar' onChange={handleTabClick} activeKey={activeKey}>
      {
        tabs.map(item => (
          <TabBar.Item key={item.key} icon={item.icon} title={item.title} />
        ))
      }
    </TabBar>
  )

}

